import { object, string } from 'yup';
import { TFunction } from 'i18next';

export function makeHazardProfileSchema(t: TFunction) {
  return object().shape({
    a: string().required(t('form.required')),
    b: string().required(t('form.required')),
    c: string().required(t('form.required')),
    d: string().required(t('form.required')),
  });
}
